import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Button, Input, Skeleton, Card } from "antd";

import { ReactComponent as SearchIcon } from "../../../../assets/images/search.svg";
import FilterButtons from "../../../shared/FilterButtons";
import EmptyState from "../../../shared/EmptyState";
import { newsFeedType } from "../../../../utils/constants/newsFeedTypes";

const { Text } = Typography;

const UserTaskScreen = (props: any) => {
  const {
    tasks,
    loading,
    loaded,
    actions: { getTask, learnerSubmitTask },
  } = props;

  const [filteredTasks, setFilteredTasks] = useState(tasks);
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("ALL");
  const filterProps = [
    { key: "ALL", value: "ALL" },
    { key: "IN PROGRESS", value: "IN PROGRESS" },
    { key: "SUBMITTED", value: "SUBMITTED" },
    { key: "APPROVED", value: "APPROVED" },
  ];
  const allSubmissions = filterProps[0];
  const inProgressSubmissions = filterProps[1];
  const submittedSubmissions = filterProps[2];
  const approvedSubmissions = filterProps[3];

  const navigate = useNavigate();

  useEffect(() => {
    if (loaded) return;
    getTask();
  }, []);

  useEffect(() => {
    let filtered = tasks;

    if (filter === "APPROVED") {
      filtered = filtered.filter(
        (user: any) => user.isFinished && user.isApproved
      );
    } else if (filter === "IN PROGRESS") {
      filtered = filtered.filter(
        (user: any) => !user.isFinished && !user.isApproved
      );
    } else if (filter === "SUBMITTED") {
      filtered = filtered.filter(
        (user: any) => user.isFinished && !user.isApproved
      );
    }

    if (searchTerm) {
      filtered = filtered.filter((task: any) =>
        task.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredTasks(filtered);
  }, [searchTerm, filter, tasks]);

  const handleSubmitTask = (id: string) => {
    learnerSubmitTask({ id, navigate });
  };

  if (loading) return <Skeleton active />;

  return (
    <>
      {tasks && tasks.length > 0 ? (
        <div>
          <div>
            <Input
              placeholder="Search"
              className="w-1/2"
              prefix={<SearchIcon className="mx-3" />}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="flex gap-5 my-5">
            <Button
              type="link"
              onClick={() => {
                setFilter(allSubmissions.value);
              }}
              className={
                filter === allSubmissions.value
                  ? "text-primary-600 font-semibold px-0 text-sm"
                  : "text-neutral-400 font-normal px-0 text-sm"
              }
            >
              {allSubmissions.key}
            </Button>
            <Button
              type="link"
              onClick={() => {
                setFilter(inProgressSubmissions.value);
              }}
              className={
                filter === inProgressSubmissions.value
                  ? "text-primary-600 font-semibold px-0 text-sm"
                  : "text-neutral-400 font-normal px-0 text-sm"
              }
            >
              {inProgressSubmissions.key}
            </Button>

            <Button
              type="link"
              onClick={() => {
                setFilter(submittedSubmissions.value);
              }}
              className={
                filter === submittedSubmissions.value
                  ? "text-primary-600 font-semibold px-0 text-sm"
                  : "text-neutral-400 font-normal px-0 text-sm"
              }
            >
              {submittedSubmissions.key}
            </Button>

            <Button
              type="link"
              onClick={() => {
                setFilter(approvedSubmissions.value);
              }}
              className={
                filter === approvedSubmissions.value
                  ? "text-primary-600 font-semibold px-0 text-sm"
                  : "text-neutral-400 font-normal px-0 text-sm"
              }
            >
              {approvedSubmissions.key}
            </Button>
          </div>
          <div className="flex flex-wrap gap-x-10 gap-y-4 mt-4 overflow-y-scroll max-h-[calc(100vh-290px)]">
            {filteredTasks?.length > 0 ? (
              filteredTasks.map((task: any, index: number) => (
                <Card
                  key={index}
                  className="w-[calc(50%-20px)] p-10 border-none shadow-sm rounded-lg"
                >
                  <div className="flex flex-col">
                    <Text className="text-neutral-600 font-semibold text-sm h-10 line-clamp-2">
                      {task?.title}
                    </Text>
                    <div className="border-b border-neutral-200 mb-4 mt-2"></div>
                    <div className="flex flex-row font-bold justify-between items-center gap-4">
                      {!task?.isFinished && !task?.isApproved && (
                        <Button
                          onClick={() => handleSubmitTask(task?.id)}
                          type="primary"
                          className="w-full"
                        >
                          Submit Task
                        </Button>
                      )}
                      {task?.isFinished && !task?.isApproved && (
                        <Text className="bg-primary-600 text-white text-base flex justify-center items-center rounded-md py-1 w-full cursor-default">
                          Submitted
                        </Text>
                      )}
                      {task?.isFinished && task?.isApproved && (
                        <Text className="bg-success-550 text-white text-base flex justify-center items-center rounded-md py-1 w-full cursor-default">
                          Approved
                        </Text>
                      )}

                      <Button
                        onClick={() => navigate(`/user/task/${task.id}`)}
                        type="primary"
                        className="w-full"
                      >
                        View
                      </Button>
                    </div>
                  </div>
                </Card>
              ))
            ) : (
              <div className="flex items-center w-full justify-center h-full py-[60px]">
                <EmptyState />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-center h-full pb-[60px]">
          <EmptyState />
        </div>
      )}
    </>
  );
};

export default UserTaskScreen;
